import type { ReactNode } from "react"
import { InfoIcon } from "components/ui/icons/info/InfoIcon"
import style from "./ModelNumberOrderHint.module.scss"

const { hint, icon } = style

type Props = { children: ReactNode; className?: string }

// One-line explanation shown under a model numbers heading (REQ-457..459).
export const ModelNumberOrderHint = ({ children, className = "" }: Props) => (
	<p className={`${hint} ${className}`}>
		<InfoIcon className={icon} />
		<span>{children}</span>
	</p>
)
